import React from 'react';

const InterestsStep = ({ options, selected, onToggle, onBack, onNext }) => (
  <div className="modal-step interests-step">
    <h5>What type of investing are you most interested in?</h5>
    <form className="option-list">
      {options.map((option, index) => {
        const isChecked = selected.includes(option);
        return (
          <label
            key={option}
            htmlFor={`interest-${index}`}
            className={`option-checkbox ${isChecked ? 'checked' : ''}`}
          >
            <input
              type="checkbox"
              id={`interest-${index}`}
              checked={isChecked}
              onChange={() => onToggle(option)}
            />
            {option}
          </label>
        );
      })}
    </form>

    <div className="modal-form-actions">
      <button type="button" className="class-modal-submit" onClick={onBack}>
         ← PREV
      </button>
      <button type="button" className="class-modal-submit" onClick={onNext}>
        Next →
      </button>
    </div>
  </div>
);

export default InterestsStep;

